declare var window: any;

const ScrollTop = {
  mounted(this: any) {
    window.scrollTo(0, 0);
  },
};

export default ScrollTop;
